import React, { Component, useEffect } from "react";
import { Link } from "react-router-dom";
import Comments from "./comments";
import moment from "moment";
import { API_URL } from "../../lib/axios";
class BlogDetails extends Component {
  componentDidMount() {
    const $ = window.$;
    if (this.props.blog) {
      $("a[data-rel^=lightcase]").lightcase({
        transition:
          "elastic" /* none, fade, fadeInline, elastic, scrollTop, scrollRight, scrollBottom, scrollLeft, scrollHorizontal and scrollVertical */,
        swipe: true,
        maxWidth: 1500,
        maxHeight: 750,
      });
    }
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    const { blog } = this.props;

    if (!blog || !blog.bloglang) return null;

    return (
      <div className="ltn__page-details-area ltn__blog-details-area mb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="ltn__blog-details-wrap">
                <div className="ltn__page-details-inner ltn__blog-details-inner">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-category">
                        <Link to="/haberler">Haber</Link>
                      </li>
                    </ul>
                  </div>
                  <h2 className="ltn__blog-title blog-detail-title">
                    {blog?.bloglang[0]?.title}
                  </h2>
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author go-top">
                        <img
                          src={publicUrl + "assets/img/favicon.png"}
                          alt="#"
                        />
                        Safkar
                      </li>
                      <li className="ltn__blog-date">
                        <i className="far fa-calendar-alt" />
                        {moment(blog.createdAt)
                          .locale(localStorage.getItem("lang"))
                          .format("MMMM Do YYYY")}
                      </li>
                    </ul>
                  </div>
                  <img
                    src={
                      API_URL +
                      "/api/image?image=" +
                      blog.image.replaceAll(" ", "%20") +
                      "&path=blog"
                    }
                    alt="Image"
                  />

                  <p
                    dangerouslySetInnerHTML={{
                      __html: blog.bloglang[0]?.content,
                    }}
                  ></p>
                  <hr />

                  <div className="row">
                    {blog?.bloggalleries.map((item) => (
                      <div className="col-lg-4 col-sm-4 col-6" key={item.id}>
                        <a
                          href={
                            API_URL +
                            "/api/image?image=" +
                            item.image.replaceAll(" ", "%20") +
                            "&path=blog/gallery"
                          }
                          data-rel="lightcase:myCollection"
                        >
                          <img
                            style={{ maxHeight: "150px", marginBottom: "15px" }}
                            src={
                              API_URL +
                              "/api/image?image=" +
                              item.image.replaceAll(" ", "%20") +
                              "&path=blog/gallery"
                            }
                            alt="Image"
                          />
                        </a>
                      </div>
                    ))}

                    {/* <div className="col-lg-4 col-sm-4 col-6">
                      <a
                        href={publicUrl + "assets/img/blog/ml810g-3.jpeg"}
                        data-rel="lightcase:myCollection"
                      >
                        <img
                          style={{ maxHeight: "150px", marginBottom: "15px" }}
                          src={publicUrl + "assets/img/blog/ml810g-3.jpeg"}
                          alt="Image"
                        />
                      </a>
                    </div> */}
                  </div>
                </div>
                {/* blog-tags */}
                <div className="ltn__blog-tags-social-media mt-80 row">
                  <div className="ltn__tagcloud-widget col-lg-12 go-top">
                    <h4>Etiketler</h4>

                    <ul>
                      {blog?.bloglang[0]?.tags.map((item) => (
                        <li>
                          <Link to="/haberler">{item}</Link>
                        </li>
                      ))}
                      {/* <li>
                        <Link to="/haberler">Savunma</Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
                <hr />
                {/* prev-next-btn */}
                {/* <div className="ltn__prev-next-btn row">
                  <div className="blog-prev col-lg-6">
                    <h6>Önceki Haber</h6>
                    <h3 className="ltn__blog-title">
                      <Link to="/haber-detay">Haber Baslık</Link>
                    </h3>
                  </div>
                  <div className="blog-prev blog-next text-right text-end col-lg-6">
                    <h6>Sıradaki Haber</h6>
                    <h3 className="ltn__blog-title">
                      <Link to="/haber-detay">Haber Baslık</Link>
                    </h3>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlogDetails;
